<template>
  <l-cache :get-data="getItem" :id="$route.query.id" ref="cache">
    <pass-Group-content :data="data" slot-scope="{data}" @refresh="$refs.cache.retry()">
      <template slot="title-actions">
        <v-btn @click="$refs.cache.retry()" class="mx-0" color="primary" flat>刷新</v-btn>
      </template>
    </pass-Group-content>
  </l-cache>
</template>
<script>

import passGroupContent from './passGroupContent'

export default {
  name: 'passGroupDetails',
  components: {passGroupContent},
  methods: {
    async getItem (key) {
      let {items} = await this.$store.dispatch('userAdmin/getPassGroups', {
        pagination: {},
        search: {key: 'id', value: key}
      })
      console.log(items)
      if (items.length !== 0) {
        let item = items[0]
        item.obgrp.editInfo = false
        item.obgrp.loading = false
        return item.obgrp
      }
      else {
        this.$L.alert('error', '未找到该通行分组')
      }
    }
  }
}
</script>

<style scoped>

</style>
